import produce from 'immer';

// TYPES
import { Types, AtualizarMenus } from './types';
import { ReducerActionRotaSP } from '../../../../../types';

export const INITIAL_STATE: AtualizarMenus = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerActionRotaSP,
): AtualizarMenus {
	return produce(state, draft => {
		switch (action.type) {
			case Types.ATUALIZAR_MENUS: {
				draft.status = 100;
				break;
			}

			case Types.ATUALIZAR_MENUS_SUCCESS: {
				draft.status = 200;
				draft.data = action.payload.data;
				break;
			}

			case Types.ATUALIZAR_MENUS_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.ATUALIZAR_MENUS_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
